import { Button, ModalActions, ModalContent, ModalTitle } from "@kaltura/ds-react-components";
import { useContext, useState } from "react";
import CreatePlaylistForm, { CreatePlaylistFormProps } from "./form/CreatePlaylistForm";
import { translate } from "@kaltura/ds-react-utils";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";
import { ConfigContext } from "@kaltura/mediaspace-shared-data-kms-config/ConfigContext";

export interface CreatePlaylistModalProps
    extends Pick<CreatePlaylistFormProps, "submitUrl" | "channelId" | "onCreate"> {
    /**
     * is the modal currently open
     */
    open: boolean;

    /**
     * cancel button callback
     */
    onCancel: () => void;
}

const formId = "create-playlist-form";
const baseClassName = "kms-ds-create-playlist-modal";

/**
 * Create personal/channel playlist modal content component
 */
export const CreatePlaylistModalContent = (props: CreatePlaylistModalProps) => {
    const { onCancel, submitUrl, channelId, onCreate } = props;

    const [processing, setProcessing] = useState(false);
    const [disableButton, setDisableButton] = useState(true);

    const sendButtonAnalytics = useButtonAnalytics();

    const updateProcessing = (value: boolean) => {
        setProcessing(value);
    };

    const updateDisableButton = (value: boolean) => {
        setDisableButton(value);
    };

    const handleCancel = () => {
        sendButtonAnalytics(
            "Cancel playlist creation - DS",
            ButtonClickAnalyticsType.CLOSE,
            undefined,
            "Addtoplaylists",
            "Modal box - Create playlist"
        );
        onCancel();
    };

    const isButtonDisabled = processing || disableButton;

    const configContext = useContext(ConfigContext);
    const isKaf = configContext.application?.isKAF;

    return (
        <>
            <ModalTitle className={`${baseClassName}-title`}>
                {channelId
                    ? isKaf
                        ? translate("Create media gallery playlist")
                        : translate("Create channel playlist")
                    : translate("Create playlist")}
            </ModalTitle>
            <ModalContent className={`${baseClassName}-content`}>
                <CreatePlaylistForm
                    formId={formId}
                    updateProcessing={updateProcessing}
                    updateDisableButton={updateDisableButton}
                    submitUrl={submitUrl}
                    channelId={channelId}
                    onCreate={onCreate}
                />
            </ModalContent>
            <ModalActions className={`${baseClassName}-actions`}>
                <Button
                    onClick={handleCancel}
                    variant={"borderless"}
                    color={"secondary"}
                    className={`${baseClassName}-actions-cancel`}
                >
                    {translate("Cancel")}
                </Button>
                <Button
                    type={"submit"}
                    loading={processing}
                    disabled={isButtonDisabled}
                    className={`${baseClassName}-actions-submit`}
                    form={formId}
                >
                    {translate("Create")}
                </Button>
            </ModalActions>
        </>
    );
};
